import React from 'react';
import './MoleculeSpinner.css';

/**
 * Branded molecule-cluster loading indicator.
 * Same 4-node constellation used on the login screen,
 * adapted for dark backgrounds (camera loading, etc.).
 */
export const MoleculeSpinner: React.FC = () => (
  <div className="ms-wrap">
    <div className="ms-cluster">
      <svg width="90" height="85" viewBox="-35 -35 130 120">
        {/* Nodes */}
        <circle className="ms-node" cx="20" cy="16" r="5" fill="#fff" style={{ animationDelay: '0.1s' }} />
        <circle className="ms-node" cx="50" cy="8" r="3" fill="#fff" style={{ animationDelay: '0.25s' }} />
        <circle className="ms-node" cx="65" cy="32" r="4" fill="#fff" style={{ animationDelay: '0.4s' }} />
        <circle className="ms-node" cx="35" cy="50" r="3" fill="#fff" style={{ animationDelay: '0.55s' }} />
        {/* Connectors */}
        <line className="ms-conn" x1="20" y1="16" x2="50" y2="8" stroke="#fff" strokeWidth="2" style={{ animationDelay: '0.5s' }} />
        <line className="ms-conn" x1="50" y1="8" x2="65" y2="32" stroke="#fff" strokeWidth="2" style={{ animationDelay: '0.65s' }} />
        <line className="ms-conn" x1="20" y1="16" x2="35" y2="50" stroke="#fff" strokeWidth="2" style={{ animationDelay: '0.8s' }} />
        {/* Squiggles — ember on dark backgrounds */}
        <path className="ms-sqgl" d="M16,12 Q6,2 -4,12 Q-14,2 -24,12 Q-34,2 -44,12" fill="none" stroke="#D4715A" strokeWidth="3" strokeLinecap="round" style={{ animationDelay: '1s' }} />
        <path className="ms-sqgl" d="M68,35 Q78,45 88,35 Q98,45 108,35" fill="none" stroke="#D4715A" strokeWidth="3" strokeLinecap="round" style={{ animationDelay: '1.1s' }} />
      </svg>
    </div>
  </div>
);
